import React, { FC, ReactNode, useEffect, useState } from 'react';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { NeedHelp } from 'aw-package-react-authentication';
import { useFooterLinks } from 'omni-package-react-core';
import { getHomePageUrl } from '~/utils/urlUtils';
import { useTranslation } from 'react-i18next';
import { getHostName } from 'omni-package-react-cms';
import MobileSmartBanner from '~/components/MobileSmartBanner';
import getSitecorePath from '~/utils/getSitecorePath';
import splashImg from './assets/images/background.jpg';
import FooterWithLogo from './LogoFooter/FooterWithLogo';

export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  interface FooterLink {
    text: string;
    url?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  }

  const footerUrl = getSitecorePath('global/footers/footer non-authenticated', true, '/api/ssc/aggregate/content/Items/footer/');
  const sitecorePath = getHostName();
  const { t } = useTranslation('App');

  const [footerLinks, setFooterLinks] = useState<(FooterLink & { target?: string | undefined })[]>([]);

  const footerLinksFromOmniCore = useFooterLinks();

  useEffect(() => {
    if (footerLinksFromOmniCore) {
      const links: FooterLink[] = [
        ...footerLinksFromOmniCore,
      ];
      setFooterLinks(links);
    }
  }, [footerLinksFromOmniCore]);

  return (
    <FormLayoutCore
      noFooterLanguageButton={false}
      mainFooterLinksUrl={footerUrl}
      mainFooterLinksDomain={`${sitecorePath}/cw`}
      mainFooterLinks={footerLinks}
      noHeaderLanguageButton
      contentBackground={`url(${splashImg})`}
      contentBackgroundRepeat="no"
      contentBackgroundPosition="50% 50%"
      contentBackgroundAttachment="fixed"
      homePageUrl={getHomePageUrl()}
      copyrightText={<FooterWithLogo copyrightText={t('copyright')} />}
    >
      <FormLayoutCore.BeforeHeader>
        <MobileSmartBanner></MobileSmartBanner>
      </FormLayoutCore.BeforeHeader>
      <FormLayoutCore.MainHeaderRightContent>
        <NeedHelp />
      </FormLayoutCore.MainHeaderRightContent>
      {children}
    </FormLayoutCore>
  );
};

export default FormLayout;
